import { createContext } from 'react'

export const SetStatusCodeContext = createContext((_: number): void => {})
